import styled from '@emotion/styled';
import { Form, List } from 'antd';
import { themeColors } from '../../../constants/themes';

export const EditPopup = styled.div`
  border: 1px dashed ${themeColors.dirtyLightBlue};
  padding: 10px 15px;
  border-radius: 4px;
`;

export const FormItem = styled(Form.Item)`
  display: flex;
  align-items: ${props => (props.labelTop ? 'flex-top' : 'center')};
  margin-bottom: 1em;
  & .ant-input,
  .ant-input-number {
    width:  ${({fullWidth}) => (fullWidth ? '100%' : '70%')};
  }
  & .ant-select {
    width:  ${({fullWidth}) => (fullWidth ? '100%' : '70%')};
  }
  & .ant-form-item-control {
    line-height: 2em;
  }
  & > .ant-form-item-label {
    line-height: 2em;
    text-align: left;
    white-space: normal;
    line-height: 1.33;
    ${({required})=> required? `
      & > .ant-form-item-label:before {
        display: inline-block;
        margin-right: 4px;
        content: "*";
        font-family: SimSun;
        line-height: 1;
        font-size: 12px;
        color: #f5222d;
      }` : ''
    }
  }
  & .ant-form-explain {
    position: relative;
    top: 0.5em;
  }
  & * {
    font-weight: normal;
  }
`;

export const ListItem = styled(List.Item)`
  border-bottom: 0 !important;
`;

export const BoxedNotification = styled.div`
  background: ${themeColors.backgroundLightBlue};
  padding: 0.5em;
  /* padding-bottom: 0.3em; */
  margin-bottom: 0.5em;
  .ant-row.ant-form-item {
    margin-bottom: 0em;
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export const Row = styled.div`
  display: flex;
  ${({justifyContent})=> justifyContent ? `justify-content: ${justifyContent};` : ''}
`;

export const SelectCol = styled.div`
  width: ${({ width }) => width || '29%'};
  display: flex;
  flex-direction: column;
  align-items: ${({ alignItems }) => alignItems || 'normal'};
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};

  &:not(:first-of-type) {
    margin-left: 18px;
  }
  &:not(:last-child) {
    margin-right: 18px;
  }
  &:last-child {
    margin-right: 5px;
  }
`;

export const To = styled.span`
  font-size: 16px;
  position: relative;
  top: 0.5em;
`;
